module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.6.23.0@babel-runtime/core-js/object/define-property.js
 ** module id = 654
 ** module chunks = 0 1
 **/